import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetRegistrationItemsDocument,
  RegistrationItemDataFragment,
  RegistrationStatus,
} from '../../types/api/graphql';

/**
 * Registrations for one practice, newest first, capped at 200 by the server.
 * Person rows are deliberately not part of this query — an overview never
 * needs them and a BSN must never leave the detail view.
 */
export function useRegistrationItems(
  healthProviderId: string | null | undefined,
  status: RegistrationStatus | null | undefined
) {
  const { data: registrationItemsData, loading: registrationItemsLoading } =
    useCacheQuery(GetRegistrationItemsDocument, {
      variables: {
        healthProviderId: healthProviderId ?? '',
        status: status ?? null,
      },
      skip: !healthProviderId,
    });

  const data = useMemo(
    () =>
      (registrationItemsData?.registrations ??
        []) as RegistrationItemDataFragment[],
    [registrationItemsData?.registrations]
  );

  return {
    data,
    loading: registrationItemsLoading,
  };
}
